import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectHash } from 'src/redux/navigation/selectors';
import {
  getNextPageNumberNotLoaded,
  getPreviousPageNumberNotLoaded,
} from 'src/redux/products/utils/pageNumbers';
import { adaptStoreToFilterPath, adaptStoreToPageURL } from './adaptStoreToPageURL';
import { buildListingsURL } from './buildListingsURL';
import { selectListingsBasePath } from './selectListingsBasePath';

const adaptStoreToAdjacentPageURL = (
  state: ReduxApplicationState,
  getAdjacentPageNumber: (state: ReduxApplicationState) => number | null,
): string | null => {
  const pageNumber = getAdjacentPageNumber(state);

  if (pageNumber === null) {
    return null;
  }

  const queryParams = adaptStoreToPageURL(state, pageNumber);
  const filterPath = adaptStoreToFilterPath(state);
  return buildListingsURL(
    selectListingsBasePath(state),
    filterPath,
    queryParams,
    selectHash(state),
  );
};

export const adaptStoreToPreviousPageURL = (state: ReduxApplicationState): string | null => {
  return adaptStoreToAdjacentPageURL(state, (currentState) => {
    return getPreviousPageNumberNotLoaded(currentState.products.pages);
  });
};

export const adaptStoreToNextPageURL = (state: ReduxApplicationState): string | null => {
  return adaptStoreToAdjacentPageURL(state, (currentState) => {
    return getNextPageNumberNotLoaded(
      currentState.products.pages,
      currentState.products.totalPages,
    );
  });
};
